import React, { useState } from 'react'
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js'
import { t } from 'i18next'
import BottomButton from '../../ui/layout/BottomButtons/BottomButton'
import { useDispatch } from 'react-redux'
import { confirmPaymentIntent } from '../../../store/actions/stripe'
import { useNavigate } from 'react-router-dom'
import { useNativeLayer } from '../../../hooks/useNativeLayer'

interface StripePaymentElementsProps {
	onReady: () => void
	back: () => void
}

const StripePaymentElementsForm = (props: StripePaymentElementsProps) => {
	const [isProcessing, setIsProcessing] = useState(false)
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { isHandshakeComplete } = useNativeLayer()

	const stripe = useStripe()
	const elements = useElements()

	const paymentElementOptions = {
		layout: 'accordion' as const,
		...(isHandshakeComplete && {
			wallets: {
				applePay: 'never' as const,
				googlePay: 'never' as const,
				link: 'never' as const,
			},
		}),
	}

	const submitHandler = async () => {
		if (!stripe || !elements) return

		elements.submit().then((data) => {
			if (!data.error) {
				setIsProcessing(true)

				dispatch(confirmPaymentIntent(stripe, elements, navigate))

				setIsProcessing(false)
			}
		})
	}

	return (
		<>
			<div style={{ margin: '16px' }}>
				<PaymentElement onReady={props.onReady} options={paymentElementOptions} />
			</div>
			{stripe && elements && (
				<div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '16px' }}>
					<BottomButton
						id='stripeUSSubmitButton'
						className={`ButtonPrimary`}
						onClick={submitHandler}
						disabled={isProcessing}
						title={t('pay')}
						grow={undefined}
					/>
					<BottomButton
						id='stripeUSCancelButton'
						className={`ButtonWhite`}
						onClick={props.back}
						disabled={false}
						title={t('cancel')}
						grow={undefined}
					/>
				</div>
			)}
		</>
	)
}

export default StripePaymentElementsForm
